// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"181": "2c32b67c365c5645","419": "d360b9e4d817ca5f","467": "9a4da062b8459e11","983": "8dd7c99cb4018dd0",}[chunkId] + ".css"
}